import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/home/home";
import Roulette from "./components/games/roulette/roulette";
import Dice from "./components/games/dice/dice";
import Settings from "./components/profile/settings";
import Fairness from "./components/profile/fairness";
import Transaction from "./components/profile/transaction";
import BetHistory from "./components/profile/bethistory";
import Withdraw from "./components/withdraw/withdraw";
import Deposit from "./components/deposit/deposit";
import Overview from "./components/verifygames/overview";
import VerifyRoulette from "./components/verifygames/verifyroulette";
import VerifyDice from "./components/verifygames/verifydice";
import Affiliate from "./components/affiliates/affiliates";

import Modals from "./components/modals/modals";
import FaqPage from "./components/faq/faq";
import SearchPage from "./components/search/search";

import Mines from "./components/games/mines/mines";
import LiveGames from "./components/games/livegames/livegames";
import SlotGames from "./components/games/slots/allslot";
import Tower from "./components/games/tower/tower";
import SlotBonanza from "./components/games/slots/bonanza";

import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./responsive.css";
const App = () => {
  return (
    <div className="App">
      <div className="main-wrapper">
        <React.Fragment>
          <Router>
            <main>
              <div className="main_content">
                <Switch>
                  <Route exact path="/" render={() => <Home />} />
                  <Route exact path="/roulette" render={() => <Roulette />} />
                  <Route path="/dice" render={() => <Dice />} />
                  <Route path="/settings" render={() => <Settings />} />
                  <Route path="/fairness" render={() => <Fairness />} />
                  <Route path="/bethistory" render={() => <BetHistory />} />
                  <Route path="/transactions" render={() => <Transaction />} />
                  <Route path="/withdraw" render={() => <Withdraw />} />
                  <Route path="/deposit" render={() => <Deposit />} />
                  <Route path="/overview" render={() => <Overview />} />
                  <Route
                    path="/verifyroulette"
                    render={() => <VerifyRoulette />}
                  />
                  <Route path="/verifydice" render={() => <VerifyDice />} />

                  <Route path="/affiliates" render={() => <Affiliate />} />
                  <Route path="/tip" render={() => <Modals />} />
                  <Route path="/faq" render={() => <FaqPage />} />
                  <Route path="/search" render={() => <SearchPage />} />
                  <Route path="/mines" render={() => <Mines />} />
                  <Route path="/livegames" render={() => <LiveGames />} />
                  <Route path="/slots" render={() => <SlotGames />} />
                  <Route path="/tower" render={() => <Tower />} />
                  <Route path="/bonanza" render={() => <SlotBonanza />} />
                </Switch>
              </div>
            </main>
          </Router>
        </React.Fragment>
      </div>
    </div>
  );
};

export default App;
